import { IIdleTimer } from 'react-idle-timer';

export interface SessionInformation extends IIdleTimer {
  setCustomSessionIdleTime: (sessionIdleInMs: number) => void; // for overriding session timeout
}

export const sessionStateMock: SessionInformation = {
  setCustomSessionIdleTime: () => null,

  start: () => true,
  reset: () => true,
  pause: () => true,
  resume: () => true,

  isIdle: () => false,
  isLeader: () => false,
  isLastActiveTab: () => false,

  getRemainingTime: () => 0,
  getElapsedTime: () => 0,
  getLastIdleTime: () => new Date(),
  getLastActiveTime: () => new Date(),
  getTotalIdleTime: () => 0,
  getTotalActiveTime: () => 0,
  getIdleTime: () => 0,
  getActiveTime: () => 0,

  activate: () => true,
  getTabId: () => '',
  getTotalElapsedTime: () => 0,
  isPrompted: () => true,
  message: () => true,
};
